export default __webpack_public_path__ + "static/media/gripofdeath.edc0170a.png";